import { CognitiveLoad as CognitiveLoadComponent } from "heat-next";

import { useSessionDetailsContext } from "@/context/session-details/session-details";

import { ComponentWrapper } from "@/pages/shared/shared.styles";

import ContentLoader from "@/components/content-loader/content-loader";
import EmptyState from "@/components/empty-state/empty-state";
import { EmptyStateType } from "@/components/empty-state/empty-state.types";

interface CognitiveLoadProps {
    isInsideModal?: boolean;
    subDimensionData?: any;
}

const CognitiveLoad = ({ isInsideModal, subDimensionData }: CognitiveLoadProps) => {
    const { customChartsData, isErrorCustomCharts, isFetchingCustomCharts } =
        useSessionDetailsContext();

    const isEmptyState = () => {
        if (isInsideModal) {
            return !subDimensionData;
        } else if (!isErrorCustomCharts && (!customChartsData || customChartsData?.length === 0)) {
            return true;
        }
    };

    if (isFetchingCustomCharts) {
        return <ContentLoader height="21.1875rem" />;
    }

    if (isErrorCustomCharts && !isFetchingCustomCharts) {
        return (
            <ComponentWrapper>
                <EmptyState
                    title="error-state:title"
                    emptyStateType={EmptyStateType.Error}
                    minHeight="18.1875rem"
                />
            </ComponentWrapper>
        );
    }

    if (isEmptyState()) {
        return (
            <ComponentWrapper>
                <EmptyState
                    title="session-detail:gauge-empty-state-description"
                    emptyStateType={EmptyStateType.Charts}
                    minHeight="18.1875rem"
                />
            </ComponentWrapper>
        );
    }

    return <CognitiveLoadComponent data={isInsideModal ? subDimensionData : customChartsData} />;
};

export default CognitiveLoad;
